// components/steps/RewardStep.js
import React, { useEffect, useState } from 'react';
import { formatEther, parseEther } from 'viem';
import { CustomDatePicker } from '../components';
import { tokenAmount } from '../../../utils/tokenAmount';

const RewardStep = ({ formData, errors, tokenBalance, tokenSymbol, tokenDecimals, onInputChange, onDateChange }) => {
    const [balanceError, setBalanceError] = useState('');
    const amount = tokenAmount(tokenBalance, tokenDecimals);
    // console.log(amount, tokenBalance, tokenDecimals, 'amountasfasdfas');
    // Convert token balance to a readable float
    const readableBalance = Number(amount?.formatted) //  tokenBalance ? parseFloat(formatEther(tokenBalance)) : 0;

    // Balance check when reward amount changes
    useEffect(() => {
        if (formData.totalRewards) {
            const rewardAmount = parseFloat(formData.totalRewards);

            if (isNaN(rewardAmount)) {
                setBalanceError('Please enter a valid number.');
            } else if (rewardAmount > readableBalance) {
                setBalanceError('Insufficient balance for this reward amount.');
            } else if (rewardAmount < 0) {
                setBalanceError('Amount cannot be negative.');
            } else {
                setBalanceError('');
            }
        } else {
            setBalanceError('');
        }
    }, [formData.totalRewards, readableBalance]);

    return (
        <div className="wrappermain">
            <div className="textformobile">
                <div className="parentmbl d-none">
                    <div className="parent">
                        <h6>Reward</h6>
                        <button>2/3</button>
                    </div>
                </div>
            </div>

            <div className="bottommainbox">
                <div className="innerboxxx">
                    <div className="innerparent">
                        <div className="left">
                            <span>
                                {formData.logoPreview ? (
                                    <img
                                        src={formData.logoPreview}
                                        className="imggginner"
                                        style={{ objectFit: 'cover' }}
                                        alt="Project logo"
                                    />
                                ) : (
                                    <img src="\assets\up.svg" className="imggginner" />
                                )}
                            </span>
                        </div>
                        <div className="right">
                            <h3>{formData.projectName || 'Project Name'}</h3>
                            <p>{formData.tagline || 'Project Tagline'}</p>
                        </div>
                    </div>
                </div>

                <div className="upper mt-3">
                    <h3>Enter Reward Amount</h3>
                    <p>
                        Balance:
                        <span className="paddinngleft">
                            <span className='relateable_text'> {readableBalance.toFixed(6)} </span>
                           {tokenSymbol}
                        </span>
                    </p>
                </div>

                <div className="innerboxxx">
                    <div className="parentinner">
                        <div className="leftmain">
                            <h3>Total Rewards *</h3>
                            <input
                                placeholder="Enter Reward Amount"
                                type="text"
                                value={formData.totalRewards}
                                onChange={(e) => onInputChange('totalRewards', e.target.value)}
                                className={balanceError ? 'input-error' : ''}
                            />
                        </div>

                        {formData.logoPreview && (
                            <div className="rightmain">
                                <span className="orange">
                                    <img src={formData.logoPreview} className="imggginner1" />
                                </span>
                            </div>
                        )}
                    </div>
                </div>

                {(errors.totalRewards || balanceError) && (
                    <p className="error-text">
                        {errors.totalRewards || balanceError}
                    </p>
                )}

                <div className="innerboxxx">
                    <CustomDatePicker
                        value={formData.poolEndDate}
                        onChange={onDateChange}
                        error={errors.poolEndDate}
                    />
                </div>

                {errors.poolEndDate && <p className="error-text">{errors.poolEndDate}</p>}
            </div>
        </div>
    );
};

export default RewardStep;
